import Head from 'next/head';
import { useRouter } from 'next/router';

import { replaceQueryParamAsOnly, urlObjectToString } from '../../utils/routing';

export const PaginationMetaLink = ({
  page = 1,
  totalPages,
  queryName,
}: {
  page?: number;
  totalPages: number;
  queryName: string;
}) => {
  const { asPath } = useRouter();

  if (typeof page !== 'number') return null;

  return (
    <Head>
      {page > 1 && page <= totalPages + 1 && (
        <link
          rel="prev"
          href={urlObjectToString(
            replaceQueryParamAsOnly(asPath, queryName, page > 2 ? page - 1 : null),
          )}
        />
      )}
      {page > -1 && page < totalPages && (
        <link
          rel="next"
          href={urlObjectToString(replaceQueryParamAsOnly(asPath, queryName, page + 1))}
        />
      )}
    </Head>
  );
};
